module.exports = __webpack_public_path__ + "images/vkb_no.svg?57880e9eb9655fab3446d4fa2c568337";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/vkb_no.svg
// module id = rm8X
// module chunks = 0